import { useAuthContext } from '../AuthProvider';
import { useOrgMembership } from './useOrgMembership';

import type { OrganizationUserType } from '@mfw/common';

/**
 * "What am I in the context I am currently acting in" — for surfaces that
 * render both inside an organization and in the org-less personal profile
 * (Home and the content lists it links to).
 *
 * Inside an organization this is the membership row for THAT organization.
 * `currentUser.type` is not: `/auth/me` carries no `:organizationId`, so the
 * backend fills it from the first of the account's rows across ALL of its
 * organizations, in no defined order — a client of the selected organization
 * who trains elsewhere was treated as a trainer here.
 *
 * In the personal profile there is no membership to read, and the account-level
 * field is the only answer there is, so it stands.
 *
 * Pass the organization a surface is mounted on; omit it for the selected one.
 */
export const useActingUserType = (
  organizationId?: null | string,
): undefined | OrganizationUserType | string => {
  const { currentUser } = useAuthContext();
  const membership = useOrgMembership(organizationId);
  return membership?.type ?? currentUser?.type ?? undefined;
};
